// helper function used to get query string param value by name, (case insensitive)
export default function getParameterByName(name, url = (global.BROWSER && window?.location.href) || null) {
  const cleanName = name.replace(/[[\]]/g, '\\$&').toLowerCase();
  const regex = new RegExp(`[?&]${cleanName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url?.toLowerCase());
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
